export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/customer_support-323b9ac847c0524091bd797bd795cbdd.svg";